import { render, staticRenderFns } from "./MatchDialog.vue?vue&type=template&id=a18d7704&"
import script from "./MatchDialog.vue?vue&type=script&lang=js&"
export * from "./MatchDialog.vue?vue&type=script&lang=js&"
import style0 from "./MatchDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports